import { defineStore } from 'pinia'
import { ref } from 'vue'

/** Lifestyle quiz — open / close. Answers are applied as they are given (R203). */
export const useLifestyleQuizStore = defineStore('lifestyleQuiz', () => {
  const isOpen = ref(false)
  /** Bumped on every open so the quiz re-reads the stored answers. */
  const session = ref(0)

  function open() {
    session.value += 1
    isOpen.value = true
  }

  function close() {
    isOpen.value = false
  }

  return { isOpen, session, open, close }
})
